import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { cn } from '@/lib/utils';
import { AvailableBadge } from '../hooks/useUserBadges';

interface BadgeCardProps {
  badge: AvailableBadge;
}

export function BadgeCard({ badge }: BadgeCardProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center p-4 rounded-xl border transition-all",
        badge.earned
          ? "bg-card border-border"
          : "bg-muted/50 border-border/50 opacity-60"
      )}
    >
      {/* Emoji/Icon */}
      <span className={cn(
        "text-3xl mb-2",
        !badge.earned && "grayscale"
      )}>
        {badge.earned ? badge.emoji : '🔒'}
      </span>

      {/* Name */}
      <p className={cn(
        "font-medium text-sm text-center",
        badge.earned ? "text-foreground" : "text-muted-foreground"
      )}>
        {badge.name}
      </p>

      {/* Description or Earned Date */}
      {badge.earned && badge.earned_at ? (
        <p className="text-xs text-muted-foreground mt-1">
          {formatDistanceToNow(new Date(badge.earned_at), { addSuffix: true })}
        </p>
      ) : (
        <p className="text-xs text-muted-foreground mt-1 text-center line-clamp-2">
          {badge.description}
        </p>
      )}
    </div>
  );
}
